var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentCenter"},_vm._l((_vm.markList),function(item,index){return _c('div',{key:index,staticClass:"contentCenter wrapper"},[_c('h4',[_vm._v(_vm._s(item.title))]),_c('div',{style:(item.imgWidth)},[_c('img',{attrs:{"src":item.imgUrl,"alt":"certification mark"}})]),_c('p',{domProps:{"innerHTML":_vm._s(item.content)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }